<template>
    <div class="fixed inset-0 bg-black/80 backdrop-blur-md flex flex-col items-center justify-center z-[9999]">
        <!-- <div class="flower-spinner m-auto">
            <img src="https://media.pafcpic.net/images/logo/pafcpic.png" class="w-48 h-48 absolute z-50" />
            <div class="dots-container ">
                <div class="bigger-dot">
                    <div class="smaller-dot"/>
                </div>
            </div>
        </div> -->
        <img class="papsi-mascot w-[40%] lg:w-1/6 mb-10" src="https://resource.pafcpic.net/assets/pia/images/elements/papsi_kalabaw.png" />
      
    </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
        data(){
            return {
            
            }
        },
})
</script>
<style scoped>
.bg-translucent {
    background-color: rgba(77, 77, 77, 0.25);
}

@keyframes mascot-wave {
    0%, 100% { 
        transform: translateY(0);
    }
    50% {
        transform: translateY(-20px);
    }
  }

  .papsi-mascot {
    animation: mascot-wave 1s ease-in-out infinite;
    transform-origin: top center;
  }

  .dots-container {
    display: inline-block;
    width: 2em;
    text-align: left;
  }

  @keyframes dot-blink {
    0% { content: ""; }
    25% { content: "."; }
    50% { content: ".."; }
    75% { content: "..."; }
    100% { content: ""; }
  }

  .dots::after {
    animation: dot-blink 2s steps(4, end) infinite;
    content: ""; /* Initial state */
  }


</style>
